import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { EcosystemSlider } from 'trellis-ecosystem';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { useFilterConfigData } from '../../filters/hooks/useFilterConfig';
import { CAROUSEL_SERVICES_PROD, SERVICE_COLORS } from '../constants/index';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function BrowsePopularPartnersSliderSection() {
  var _filterConfigResult$d;
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const filterConfigResult = useFilterConfigData();
  const trackSliderButtonClicked = useCallback(direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggestion section ${direction} arrow clicked`,
      itemIndex: 0,
      subscreen: Subscreens.SUGGESTION_SECTION
      // To do: add section, type, and value
    }));
  }, [trackMarketplaceEvent]);
  const onLinkClick = index => {
    trackMarketplaceEvent(getSearchResultClickedEvent({
      resultCount: CAROUSEL_SERVICES_PROD.length,
      resultIndex: index,
      resultType: 'SOLUTIONS_PARTNERS'
    }));
  };
  const data = (_filterConfigResult$d = filterConfigResult.data) === null || _filterConfigResult$d === void 0 ? void 0 : _filterConfigResult$d.result.filterConfigs.PROFILE_CATALOG_SERVICES.options;
  if (!data) return null;
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.SUGGESTION_SECTION,
    children: /*#__PURE__*/_jsx(View, {
      "data-test-id": "browse-popular-partners-section",
      marginBlockEnd: "1000",
      marginBlockStart: "400",
      maxInlineSize: "100%",
      children: /*#__PURE__*/_jsx(EcosystemSlider, {
        cardWidth: 306,
        gradientColor: "fill-surface-recessed",
        onScrollButtonClick: trackSliderButtonClicked,
        scrollButtonTop: "32.5%",
        title: unescapedText('marketplaceStorefront.sliderSection.browsePartners'),
        children: CAROUSEL_SERVICES_PROD.map((card, index) => {
          var _card$icon;
          const cardData = data.find(d => d.slug === card.slug);
          if (!cardData) return null;
          return /*#__PURE__*/_jsx(RouterLink, {
            color: "text-core-default",
            onClick: () => onLinkClick(index),
            to: `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?eco_PROFILE_CATALOG_SERVICES=${cardData.value}`,
            use: "unstyled",
            children: /*#__PURE__*/_jsxs(CardWrapper, {
              alignItems: "center",
              blockSize: "104px",
              display: "flex",
              flexDirection: "row",
              gap: "400",
              inlineSize: "306px",
              margin: "0",
              padding: "500",
              children: [/*#__PURE__*/_jsx(IconCircle, {
                backgroundColor: SERVICE_COLORS[index % SERVICE_COLORS.length],
                borderStyle: "none",
                color: "icon-core-default",
                "data-prevent-inherit-border-radius": true,
                icon: (_card$icon = card.icon) !== null && _card$icon !== void 0 ? _card$icon : WebsiteIcon,
                size: "400"
              }), /*#__PURE__*/_jsx(Text, {
                as: "h4",
                typography: "heading-100",
                children: cardData.text
              })]
            })
          }, cardData.value);
        })
      })
    })
  });
}